import variables from '../variables';

const performance = [
    variables.colors.green,
    variables.colors.yellowDark,
    variables.colors.red,
];

export default performance;
